var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BCXForm,{staticClass:"invoice-address-data-editor",attrs:{"fields":_setup.fields,"data":_setup.addressDataVM,"error-messages":_setup.errorMessagesVM,"error-display-mode":'block'},on:{"update:data":function($event){_setup.addressDataVM=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }